var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.787 14V7.43H0V5.067h1.787v-2.02C1.787 1.457 2.842 0 5.275 0c.984 0 1.713.092 1.713.092L6.93 2.3s-.742-.007-1.553-.007c-.877 0-1.017.393-1.017 1.046v1.727H7L6.885 7.43H4.36V14H1.787Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h7v14H0z"
  })))));
};
export default SvgFacebookLogo;